<div>
  <strong>{{item.translation_key_label||item.label| translation|translationFromString | transformText :item?.text_transform_label}}</strong>
  <div *ngIf="item.instructions">{{item.translation_key_instructions||item.instructions| translation|translationFromString | transformText :item?.text_transform_key}}</div>
</div>
<p-tabs value="from_url">
  <p-tablist>
    <p-tab value="from_url">{{'from_url'| translation}}</p-tab>
    <p-tab value="from_xml">{{'from_xml'| translation}}</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="from_url">
      <div class="form-field" [ngClass]="{'mat-form-field-invalid':item.notvalid,'ng-invalid':this.item.notvalid}" style="width:80%" >
        <label for=" url">URL</label>
        <input pInputText type="url" [placeholder]="'configuration_url'| translation" [(ngModel)]="url" name="url" fluid/>
      </div>
      <button pButton (click)="getSettings()">{{'configuration_get'| translation}}</button>
    </p-tabpanel>
    <p-tabpanel value="from_xml">
      <div>
        <label for="input">XML</label>
        <textarea style="height:200px;width:100%;" [(ngModel)]="input" pTextarea fluid name="input"></textarea>
      </div>
      <button pButton (click)="dataInput()">{{'configuration_process'| translation}}</button>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
